import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./plugin/elementUI";
Vue.config.productionTip = false
import './permission' // permission control
import echarts from "./plugin/echars";
Vue.prototype.$echarts = echarts;

// bus总线
import bus from './tools/bus'
Vue.prototype.$bus = bus

// dayjs
import dayjs from "dayjs"
Vue.prototype.$dayjs = dayjs;

// 公历
import calendar from "js-calendar-converter"
Vue.prototype.$calendar = calendar; //calendar是一个对象，里面有许多方法和属性
import LoadingOverlay from './components/loading.vue';

Vue.component('loading-overlay', LoadingOverlay);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

// router.beforeEach(async(to, from, next) => {
//     if (to.path != '/login') {
//         let token = window.sessionStorage.getItem("token")
//         if (token) {
//         //     const roles=['admin']
//         //   // generate accessible routes map based on roles
//         //   const accessRoutes = await store.dispatch('generateRoutes', roles)

//         //   // dynamically add accessible routes
//         //   router.addRoutes(accessRoutes)
//         next()
//         } else {
//             console.log("store========",store);
//             next('/login')
//         }
//     } else {
//         console.log("store========",store);
//         next()
//     }
// })
